/**
 * 万达普惠 APP 下载（微信引导 / App Store / APK）
 */
export default {
  data() {
    return {
      downUrl: '',
      tip: false,
      isWx: false,
      isIos: false
    }
  },
  methods: {
    closeTip() {
      this.tip = false
    },
    handleDownload() {
      if (this.isWx) {
        this.tip = true
      } else if (this.downUrl) {
        window.location.href = this.downUrl
      }
    },
    initDownloadEnv() {
      const ua = navigator.userAgent
      this.isWx =
        ua.toLowerCase().match(/MicroMessenger/i) === 'micromessenger'
      this.isIos = /iPhone|iPad|iPod|iOS/i.test(ua)
      if (this.isWx) {
        this.tip = true
      } else if (this.isIos) {
        this.downUrl = 'https://apps.apple.com/cn/app/id1117322012'
      } else {
        this.downUrl = 'https://kyh.wandaloans.com/apkdownload/wdd.apk'
      }
    }
  },
  mounted() {
    this.initDownloadEnv()
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/wdd-download.js